



















































import { defineComponent } from "@vue/composition-api";
import emitter from "@/lib/emitter";
import { NotificationData } from "@/types";
import { EVENTS } from "@/const";
import BaseIcon from "@/components/Base/BaseIcon";
import BaseAvatar from "@/components/BaseAvatar";
import BaseButton from "@/components/BaseButton";
import BaseSpinner from "@/components/BaseSpinner";
import ContentFeedCover from "@/components/ContentFeedCover";

export default defineComponent({
  name: "NotificationBar",
  components: { ContentFeedCover, BaseSpinner, BaseButton, BaseIcon, BaseAvatar },
  data() {
    return {
      notification: null as NotificationData | null,
      timeoutId: 0 as NodeJS.Timeout | number,
      spinnerKey: 0 as number,
    };
  },
  computed: {
    position(): string {
      return this.notification?.position ?? "bottom";
    },
  },
  methods: {
    setTimeout(period: number) {
      typeof this.timeoutId === "number" ? clearTimeout(this.timeoutId) : clearTimeout(this.timeoutId);
      this.timeoutId = setTimeout(this.clearNotification, period);
    },

    onButtonClick() {
      this.notification?.button?.cb && this.notification?.button?.cb();
      this.clearNotification();
    },

    onNotificationClick() {
      this.notification?.onNotificationClick && this.notification?.onNotificationClick();
      this.clearNotification();
    },

    async addNotification(notification?: NotificationData) {
      this.clearNotification();
      if (!notification) return;
      await this.$nextTick();
      this.notification = notification;
      this.spinnerKey++;
      this.setTimeout(notification.timeout ?? 4000);
    },

    clearNotification() {
      typeof this.timeoutId === "number" ? clearTimeout(this.timeoutId) : clearTimeout(this.timeoutId);
      this.notification = null;
      this.timeoutId = 0;
    },
  },
  mounted() {
    (window as any).emitter = emitter;
    emitter.on<NotificationData>(EVENTS.NOTIFICATION_SHOW, this.addNotification);
    emitter.on<void>(EVENTS.NOTIFICATION_HIDE, this.clearNotification);
  },
  beforeDestroy() {
    emitter.off<NotificationData>(EVENTS.NOTIFICATION_SHOW, this.addNotification);
    emitter.off<void>(EVENTS.NOTIFICATION_HIDE, this.clearNotification);
  },
});
